<template>
  <div id="app">
    <tab-menu class="header-view"></tab-menu>
    <footer-view class="footer-view"></footer-view>
    <router-view/>
  </div>
</template>

<script>

// vueファイルのコンポネントを読み込む。

import TabMenu from '@/components/TabMenu'
import FooterView from '@/components/FooterView'

// <tab-menu> もしくは <TabMenu>が使える。
export default {
  // name: 'App',
  components: {
    TabMenu,
    FooterView
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  /* background-color: pink; */
}

/*  モバイルなら*/
@media screen and (max-width:781px) {
  .footer-view {
    display: block;
  }
  .header-view {
    display: none;
  }
}

/*  WEBなら*/
@media screen and (min-width:781px) {
  .footer-view {
    display: none;
  }
  .header-view {
    display: block;
  }
}



</style>



// WEBPACK FOOTER //
// src/App.vue